import { def, s } from '@kosmod/pancake/shapes';
import * as three from 'three';
import { Vector, Vector2 } from '@kosmod/kit';
import { Surface, SurfaceID } from './surface';

export type TheatrePosition =
  | { type: 'grid', surfaceId: SurfaceID, vector: Vector<2> }

export const theatrePositionDef = def<TheatrePosition>()(s.union([
  s.o({ type: s.l('grid'), surfaceId: SurfaceID, vector: Vector2.def }),
]));

export const TheatrePosition = {
  def: theatrePositionDef,
  copyToVector3(position: TheatrePosition, target: three.Vector3 = new three.Vector3()): three.Vector3 {
    return target.copy({
      x: position.vector.x,
      y: 0,
      z: position.vector.y
    })
  },
  snapToSquareGrid(position: TheatrePosition): TheatrePosition {
    return {
      ...position,
      vector: {
        x: Math.round(position.vector.x - .5),
        y: Math.round(position.vector.y - .5),
      }
    }
  },
  snapToSquareGridVertex(position: TheatrePosition): TheatrePosition {
    return {
      ...position,
      vector: {
        x: Math.round(position.vector.x),
        y: Math.round(position.vector.y),
      }
    }
  },
  equal(left: TheatrePosition, right: TheatrePosition) {
    if (left.surfaceId !== right.surfaceId)
      return false;

    return (
      left.vector.x === right.vector.x
      && left.vector.y === right.vector.y
    )
  },
  copy(original: TheatrePosition): TheatrePosition {
    return {
      ...original,
      vector: { ...original.vector }
    }
  }
}

export type TheatreMatrix4 = [
  m0: number, m1: number, m2: number, m3: number,
  m4: number, m5: number, m6: number, m7: number,
  m8: number, m9: number, m10: number, m11: number,
  m12: number, m13: number, m14: number, m15: number, 
];
export const TheatreMatrix4 = s.ref<TheatreMatrix4>()(s.t([
  s.num, s.num, s.num, s.num,
  s.num, s.num, s.num, s.num,
  s.num, s.num, s.num, s.num,
  s.num, s.num, s.num, s.num,
]));
